// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2SPWZ","productName":"Table_productName__2nEUH"};